import { AllocationScenarioValuationModel } from 'api';
import { ValuationsApproach } from 'common/types/valuation';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { EquityAllocationCellCustomData } from 'pages/ValuationsAllocation/allocation/EquityAllocation/config';
import {
  OnChangeType,
  UpdateAllocationScenariosWithRelated,
} from 'pages/ValuationsAllocation/hooks/useEquityAllocationInputHandlers/types';
import { UpdateMainSpreadsheetsParams } from 'pages/ValuationsAllocation/types';
import { isCapTableSelectionCell } from 'pages/ValuationsAllocation/util/cellValidators';

interface HandleCapTableSelectionParams {
  cell: ICell<EquityAllocationCellCustomData>;
  allocationScenarios: AllocationScenarioValuationModel[];
  approaches: ValuationsApproach[];
  cells: any;
  onChange: OnChangeType;
  updateAllocationScenariosWithRelated: UpdateAllocationScenariosWithRelated;
  updateMainSpreadsheets: (params?: UpdateMainSpreadsheetsParams) => void;
  updateSecurities: (allocationScenarios: AllocationScenarioValuationModel[]) => any[];
}

/**
 * Handles changes to cap table selection cells in the equity allocation sheet.
 * Updates securities and refreshes allocation scenarios.
 */
export const handleCapTableSelection = async (params: HandleCapTableSelectionParams): Promise<void> => {
  const {
    cell,
    allocationScenarios,
    approaches,
    cells,
    onChange,
    updateAllocationScenariosWithRelated,
    updateMainSpreadsheets,
    updateSecurities,
  } = params;

  if (!isCapTableSelectionCell(cell)) {
    return;
  }

  const updatedSecurities = updateSecurities(allocationScenarios);

  updateMainSpreadsheets({ updatedSecurities });

  await updateAllocationScenariosWithRelated(
    {
      allocationScenarios,
      approaches,
    },
    cells,
    onChange
  );

  // After allocation-results API mutates scenario_values, rebuild columns so a subsequent
  // workbook evaluate (from securities/config refresh) cannot restore stale present/aggregate data.
  // Pass updatedSecurities: `securities` in updateMainSpreadsheets' closure can still be stale
  // after await (setSecurities from updateSecurities has not re-bound this callback yet).
  updateMainSpreadsheets({ updatedSecurities });
};
